import * as Yup from "yup";

export const PARAM_VALIDATION = Yup.object().shape({
  PM_max: Yup.number()
    .required("Enter a PM Max value")
    .min(0, "Probability must be between 0 and 1")
    .max(1, "Probability must be between 0 and 1"),
  PM_min: Yup.number()
    .required("Enter a PM Min value")
    .min(0, "Probability must be between 0 and 1")
    .max(1, "Probability must be between 0 and 1")
    .test("relations", "Min PM must be less than Max PM", function (min) {
      return min < this.parent.PM_max;
    }),
  PD_max: Yup.number()
    .required("Enter a PD Max value")
    .min(0, "Probability must be between 0 and 1")
    .max(1, "Probability must be between 0 and 1"),
  PD_min: Yup.number("Enter a PD Min value")
    .required()
    .min(0, "Probability must be between 0 and 1")
    .max(1, "Probability must be between 0 and 1")
    .test("relations", "Min PD must be less than Max PD", function (min) {
      return min < this.parent.PD_max;
    }),
  PA: Yup.number()
    .required("Enter a PA value")
    .min(0.1, "PA must be between 0.1 and 1")
    .max(1, "PA must be between 0.1 and 1"),
  N_quiescent: Yup.number()
    .required("Enter a quiescent value")
    .integer("Value must be an integer")
    .min(1, "Value must be between 1 and 10")
    .max(10, "Value must be between 1 and 10"),
  N_proliferative: Yup.number()
    .required("Enter a proliferative value")
    .integer("Value must be an integer")
    .min(1, "Value must be between 1 and 12")
    .max(12, "Value must be between 1 and 12"),
  N_death: Yup.number()
    .required("Enter a death value")
    .integer("Value must be an integer")
    .min(1, "Value must be between 1 and 12")
    .max(12, "Value must be between 1 and 12"),
  t_transformation: Yup.number()
    .required("Enter a transformation value")
    .integer("Value must be an integer")
    .min(2, "Value must be between 2 and 20")
    .max(20, "Value must be between 2 and 20"),
  init_cell_type: Yup.string().required("Select a valid cell type"),
  grid_type: Yup.string().required("Select a valid lattice type"),
  lattice_size: Yup.string().required("Select a valid lattice size"),
});
